import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ThemeModeProvider } from "./themeContext";
import { AuthProvider } from "./auth/AuthProvider";
import { CycleFilterProvider } from "./cycleFilterContext";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AuthProvider>
      <ThemeModeProvider>
        <CycleFilterProvider>
          <App />
        </CycleFilterProvider>
      </ThemeModeProvider>
    </AuthProvider>
  </React.StrictMode>
);
